const getPhoneMask = (event) => {
  if (event.target.value.length === 0) {
    event.target.value += `+`;
  }
};

export { getPhoneMask };
